import React from 'react'

import { GetCustomerCopyFunc, WORKLIFE_SERVICE_IDS } from '@lyrahealth-inc/shared-app-logic'

import { DEFAULT_WORKLIFE_SERVICES, getCarelonDefaultWorkLifeServices } from './default'
import { WorkLifeIconDependentCare } from '../atoms/icons/WorkLifeIcons'

export const roche: GetCustomerCopyFunc = () => {
  const CARELON_WORKLIFE_SERVICES = getCarelonDefaultWorkLifeServices('roche')
  return {
    workLifeServices: [
      DEFAULT_WORKLIFE_SERVICES.LEGAL_SERVICES,
      DEFAULT_WORKLIFE_SERVICES.FINANCIAL_SERVICES,
      DEFAULT_WORKLIFE_SERVICES.IDENTITY_THEFT,
      {
        identifiers: WORKLIFE_SERVICE_IDS.DEPENDENT_CARE,
        title: 'Elder Care',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        paragraph: 'Get assistance finding elder care.',
        bullets: [],
        CTA: 'Find elder care',
        PATH: 'https://clients.brighthorizons.com/roche',
      },
    ],
    carelonWorkLifeServices: [
      CARELON_WORKLIFE_SERVICES.LEGAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.FINANCIAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.IDENTITY_THEFT,
      {
        identifiers: WORKLIFE_SERVICE_IDS.DEPENDENT_CARE,
        title: 'Elder Care',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        paragraph: 'Get assistance finding elder care.',
        bullets: [],
        CTA: 'Find elder care',
        PATH: 'https://clients.brighthorizons.com/roche',
      },
    ],
  }
}
